import styled from 'styled-components';

export const ChargingPoint = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 1rem 0;
`;
